<template>
  <a 
    href="#" 
    class="remove-saved-content-link focus-link-v2"
    @click.prevent="removeContent"
    @keydown.enter.prevent="removeContent"
  >
    <span v-if="!loading">{{ props.removeText }}</span>
    <span v-else>
      <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
    </span>
  </a>
</template>

<script setup>
import { ref, defineProps } from 'vue';
import ApiService from '@utils/services/api-service';

const props = defineProps({
  contentType: {
    type: String,
    required: true,
    validator: (value) => ['published_course', 'published_path'].includes(value)
  },
  publishedCourseId: {
    type: String,
    default: null
  },
  publishedPathId: {
    type: String,
    default: null
  },
  contentDomainId: {
    type: String,
    default: null
  },
  removeText: {
    type: String,
    required: true
  },
  errorMessage: {
    type: String,
    required: true
  }
});

const loading = ref(false);

const removeContent = async () => {
  if (loading.value) return;

  const params = {
    content_type: props.contentType,
    is_active: false,
  };

  if (props.contentType === 'published_course') {
    params.published_course_id = props.publishedCourseId;
  } else if (props.contentType === 'published_path') {
    params.published_path_id = props.publishedPathId;
  }

  try {
    loading.value = true;
    
    if (props.contentDomainId) {
      await ApiService.saveContentForLaterWithDomain(params, props.contentDomainId);
    } else {
      const contentId = props.contentType === 'published_course' 
        ? props.publishedCourseId 
        : props.publishedPathId;
      
      await ApiService.saveContentForLater(contentId, params);
    }
    
    const successEvent = new CustomEvent('saved-content-removed', {
      detail: {
        contentType: props.contentType,
        publishedCourseId: props.publishedCourseId,
        publishedPathId: props.publishedPathId
      },
      bubbles: true
    });
    document.dispatchEvent(successEvent);
    
  } catch (error) {
    const errorEvent = new CustomEvent('save-content-error', {
      detail: {
        message: props.errorMessage,
        contentType: props.contentType,
        publishedCourseId: props.publishedCourseId,
        publishedPathId: props.publishedPathId
      },
      bubbles: true
    });
    document.dispatchEvent(errorEvent);
  } finally {
    loading.value = false;
  }
};
</script>
